<mat-icon aria-hidden="false" aria-label="Forwarded">reply</mat-icon>
<i>Forwarded</i>
